import React, { memo } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

const StatCard = ({ title, value, icon, trend, trendLabel, subtitle }) => {
  const trendUp = trend != null && trend >= 0;
  const trendDown = trend != null && trend < 0;

  return (
    <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 p-4 flex flex-col gap-2 shadow-[0_1px_2px_0_rgba(10,13,18,0.05)]">
      <div className="flex items-center justify-between">
        <span className="text-gray-500 dark:text-gray-400 text-sm font-medium">{title}</span>
        {icon}
      </div>
      <p className="text-2xl font-bold text-gray-800 dark:text-gray-100">{value}</p>
      {(trend != null || trendLabel) && (
        <div className="flex items-center gap-1.5 text-xs">
          {trend != null && (
            <span
              className={`flex items-center gap-0.5 font-medium ${
                trendUp ? "text-success-600 dark:text-success-400" : "text-error-600 dark:text-error-400"
              }`}
            >
              {trendUp ? (
                <TrendingUp size={14} strokeWidth={2} />
              ) : (
                <TrendingDown size={14} strokeWidth={2} />
              )}
              {Math.abs(trend)}%
            </span>
          )}
          {trendLabel && (
            <span className="text-gray-500 dark:text-gray-400">{trendLabel}</span>
          )}
        </div>
      )}
      {subtitle && (
        <p className="text-xs text-gray-400 dark:text-gray-500">{subtitle}</p>
      )}
    </div>
  );
};

export default memo(StatCard);
